import { EnvService } from '@aipb/gulliver/env/util';
import { PersonalContentPermissionService } from '@aipb/gulliver/personal-content/auth';
import { AuthService, LoginRequiredDialogService } from '@aipb/shared/auth';
import { SnackbarService } from '@aipb/shared/util/snackbar';
import { UseCase } from '@aipb/shared/util/usecase';
import { inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PersonalContentFeatureAvailableUseCase implements UseCase<unknown, boolean> {
  private auth = inject(AuthService);
  private personalContentPermission = inject(PersonalContentPermissionService);
  private env = inject(EnvService);
  private loginRequiredDialogService = inject(LoginRequiredDialogService);
  private snackbar = inject(SnackbarService);

  get canUseFeature() {
    return this.personalContentPermission.canUsePersonalContent || this.env.isPersonalContentEnabled;
  }

  get canAddToFavorites() {
    return (
      this.auth.isLoggedIn() &&
      this.personalContentPermission.canUsePersonalContent &&
      this.env.isPersonalContentEnabled
    );
  }

  execute() {
    if (!this.auth.isLoggedIn() && this.canUseFeature) {
      this.loginRequiredDialogService.open();
      return false;
    }

    if (!this.canAddToFavorites) {
      this.snackbar.open('personal_content.messages.feature_not_enabled', 'info', {
        duration: 5000
      });
      return false;
    }

    return true;
  }
}
